"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembersTableColumn = void 0;
var MembersTableColumn;
(function (MembersTableColumn) {
    MembersTableColumn[MembersTableColumn["Name"] = 0] = "Name";
    MembersTableColumn[MembersTableColumn["CampaignPosts"] = 1] = "CampaignPosts";
    MembersTableColumn[MembersTableColumn["Influence"] = 2] = "Influence";
    MembersTableColumn[MembersTableColumn["Fans"] = 3] = "Fans";
    MembersTableColumn[MembersTableColumn["TrueReach"] = 4] = "TrueReach";
    MembersTableColumn[MembersTableColumn["Skills"] = 5] = "Skills";
    MembersTableColumn[MembersTableColumn["Location"] = 6] = "Location";
    MembersTableColumn[MembersTableColumn["CustomVariable"] = 7] = "CustomVariable";
    MembersTableColumn[MembersTableColumn["ContactInfo"] = 8] = "ContactInfo";
    MembersTableColumn[MembersTableColumn["Budget"] = 9] = "Budget";
    MembersTableColumn[MembersTableColumn["Email"] = 10] = "Email";
    MembersTableColumn[MembersTableColumn["Tags"] = 11] = "Tags";
    MembersTableColumn[MembersTableColumn["Stage"] = 12] = "Stage";
    MembersTableColumn[MembersTableColumn["Campaigns"] = 13] = "Campaigns";
    MembersTableColumn[MembersTableColumn["Agreement"] = 14] = "Agreement";
    MembersTableColumn[MembersTableColumn["Owner"] = 15] = "Owner";
    MembersTableColumn[MembersTableColumn["InviteStatus"] = 16] = "InviteStatus";
    MembersTableColumn[MembersTableColumn["StoriesConnected"] = 17] = "StoriesConnected";
    MembersTableColumn[MembersTableColumn["YoutubeConnected"] = 18] = "YoutubeConnected";
    MembersTableColumn[MembersTableColumn["TwitterReach"] = 19] = "TwitterReach";
    MembersTableColumn[MembersTableColumn["InstagramReach"] = 20] = "InstagramReach";
    MembersTableColumn[MembersTableColumn["FacebookReach"] = 21] = "FacebookReach";
    MembersTableColumn[MembersTableColumn["YoutubeReach"] = 22] = "YoutubeReach";
    MembersTableColumn[MembersTableColumn["TwitterFollowers"] = 23] = "TwitterFollowers";
    MembersTableColumn[MembersTableColumn["InstagramFollowers"] = 24] = "InstagramFollowers";
    MembersTableColumn[MembersTableColumn["FacebookFans"] = 25] = "FacebookFans";
    MembersTableColumn[MembersTableColumn["YoutubeSubscribers"] = 26] = "YoutubeSubscribers";
    MembersTableColumn[MembersTableColumn["BlogMonthlyVisitors"] = 27] = "BlogMonthlyVisitors";
    MembersTableColumn[MembersTableColumn["InstagramEngagement"] = 28] = "InstagramEngagement";
    MembersTableColumn[MembersTableColumn["InstagramEngagementRate"] = 29] = "InstagramEngagementRate";
    MembersTableColumn[MembersTableColumn["FacebookEngagement"] = 30] = "FacebookEngagement";
    MembersTableColumn[MembersTableColumn["FacebookEngagementRate"] = 31] = "FacebookEngagementRate";
    MembersTableColumn[MembersTableColumn["YoutubeEngagement"] = 32] = "YoutubeEngagement";
    MembersTableColumn[MembersTableColumn["YoutubeEngagementRate"] = 33] = "YoutubeEngagementRate";
    MembersTableColumn[MembersTableColumn["TwitterAges"] = 34] = "TwitterAges";
    MembersTableColumn[MembersTableColumn["InstagramAges"] = 35] = "InstagramAges";
    MembersTableColumn[MembersTableColumn["InstagramBusinessAges"] = 36] = "InstagramBusinessAges";
    MembersTableColumn[MembersTableColumn["InstagramBusinessCountries"] = 37] = "InstagramBusinessCountries";
    MembersTableColumn[MembersTableColumn["InstagramBusinessMonthlyReach"] = 38] = "InstagramBusinessMonthlyReach";
    MembersTableColumn[MembersTableColumn["Notes"] = 39] = "Notes";
    MembersTableColumn[MembersTableColumn["BrandScore"] = 40] = "BrandScore";
    MembersTableColumn[MembersTableColumn["Feedback"] = 41] = "Feedback";
    MembersTableColumn[MembersTableColumn["ExpectedPosts"] = 42] = "ExpectedPosts";
    MembersTableColumn[MembersTableColumn["PredictedEngagements"] = 43] = "PredictedEngagements";
    MembersTableColumn[MembersTableColumn["PredictedEngRate"] = 44] = "PredictedEngRate";
    MembersTableColumn[MembersTableColumn["PredictedReach"] = 45] = "PredictedReach";
    MembersTableColumn[MembersTableColumn["PredictedEMV"] = 46] = "PredictedEMV";
    MembersTableColumn[MembersTableColumn["PredictedCPE"] = 47] = "PredictedCPE";
    MembersTableColumn[MembersTableColumn["PredictedCPM"] = 48] = "PredictedCPM";
    MembersTableColumn[MembersTableColumn["PredictedSocialROI"] = 49] = "PredictedSocialROI";
    MembersTableColumn[MembersTableColumn["TiktokReach"] = 50] = "TiktokReach";
    MembersTableColumn[MembersTableColumn["TiktokFollowers"] = 51] = "TiktokFollowers";
    MembersTableColumn[MembersTableColumn["TiktokEngagement"] = 52] = "TiktokEngagement";
    MembersTableColumn[MembersTableColumn["TiktokEngagementRate"] = 53] = "TiktokEngagementRate";
    MembersTableColumn[MembersTableColumn["InstagramStoriesReach"] = 54] = "InstagramStoriesReach";
})(MembersTableColumn = exports.MembersTableColumn || (exports.MembersTableColumn = {}));
//# sourceMappingURL=membersTableColumn.enum.js.map